import { Hero } from "@/components/home/Hero";
import {
  WhoIsAutomex, Ecosystem, InfraShowcase, TechShowcase, Differentiator,
  IndustriesGrid, GreenBrownfield, ExecutionTimeline, WhyAutomex,
  MaterialHandling, ProjectsGrid, ContactBand,
} from "@/components/home/Sections";
import { useSeo } from "@/hooks/useSeo";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "AutoMex Group",
  description: "Industrial infrastructure, project execution, machinery, material handling and technology solutions for modern manufacturing.",
  url: "https://automex-platform.emergent.host/",
  slogan: "Building Industry. Enabling Technology.",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Pune",
    addressRegion: "Maharashtra",
    addressCountry: "IN",
  },
  email: "info@automexgroup.in",
  telephone: "+91-70586-28066",
};

export default function Home() {
  useSeo({
    title: "AutoMex Group | Industrial Infrastructure & Technology Company in Pune",
    description: "AutoMex delivers industrial infrastructure, turnkey project execution, PEB, industrial machinery, automation and material handling solutions for manufacturing facilities in Pune.",
    path: "/",
    jsonLd,
  });
  return (
    <>
      <Hero />
      <WhoIsAutomex />
      <Ecosystem />
      <InfraShowcase />
      <TechShowcase />
      <Differentiator />
      <IndustriesGrid />
      <GreenBrownfield />
      <ExecutionTimeline />
      <WhyAutomex />
      <MaterialHandling />
      <ProjectsGrid />
      <ContactBand />
    </>
  );
}
